export * from './lib/english/english.translations';
export * from './lib/hebrew/hebrew.translations';
export * from './lib/portuguese/portuguese.translations';
export * from './localeConfig';
export * from './translation-types';